import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import BottomNav from "@/components/site/BottomNav";
import FloatingReward from "@/components/site/FloatingReward";

const SiteLayout = ({ children }) => (
  <div className="min-h-screen bg-background flex flex-col">
    <Header />
    <main className="flex-1 pb-20 md:pb-0">{children}</main>
    <Footer />
    <BottomNav />
    <FloatingReward />
  </div>
);

export default SiteLayout;
